import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiTarget, FiMapPin } from 'react-icons/fi';

export default function GiantTitan({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Ativo sob Sigilo';
    const price = data?.preco || data?.price;
    const location = data?.bairro || data?.location || 'Localização Restrita';
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : price || 'Consulte';

    return (
        <motion.div 
            initial={{ opacity: 0, x: 50 }} 
            animate={{ opacity: 1, x: 0 }}
            className="w-full h-[650px] flex overflow-hidden rounded-[4rem] border border-[var(--border-color)] shadow-2xl relative"
            style={{ backgroundColor: 'var(--bg-card)' }}
        >
            {/* 📸 ALA OESTE: IMAGEM DE ALTA DEFINIÇÃO */}
            <div className="w-1/2 h-full overflow-hidden relative group">
                <img 
                    src={mainImage} 
                    className="w-full h-full object-cover transition-transform duration-[3s] group-hover:scale-110" 
                    alt={title}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent" />
                
                {/* Tag de Status Flutuante */}
                <div className="absolute top-10 left-10">
                    <span className="px-5 py-2 rounded-full bg-black/60 backdrop-blur-xl border border-white/10 text-[9px] font-black uppercase tracking-[0.4em] text-white flex items-center gap-3">
                        <div className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ backgroundColor: color || 'var(--accent-color)' }} />
                        Disponibilidade Instantânea
                    </span>
                </div>
            </div>

            {/* 📄 ALA LESTE: DOSSIÊ TÁTICO */}
            <div className="w-1/2 p-20 flex flex-col justify-center space-y-10 relative overflow-hidden">
                {/* Marca d'água de fundo */}
                <FiTarget className="absolute -right-10 -bottom-10 text-auto opacity-5" size={300} />

                <div className="space-y-4">
                    <div className="w-20 h-1.5 rounded-full" style={{ backgroundColor: color || 'var(--accent-color)' }} />
                    <h2 className="text-7xl font-black uppercase tracking-tighter leading-[0.85] text-auto" style={{ color: 'var(--text-primary)' }}>
                        {title}
                    </h2>
                    <p className="flex items-center gap-3 text-auto opacity-40 font-black text-[11px] tracking-[0.3em] uppercase">
                        <FiMapPin style={{ color: color || 'var(--accent-color)' }} /> {location}
                    </p>
                </div>

                <div className="space-y-2">
                    <span className="text-[9px] font-black uppercase tracking-[0.5em] opacity-30">Avaliação do Ativo</span>
                    <div className="text-6xl font-black text-auto tracking-tighter" style={{ color: 'var(--text-primary)' }}>
                        {formattedPrice}
                    </div>
                </div>

                <div className="pt-6">
                    <button 
                        className="group flex items-center gap-6 text-xs font-black uppercase tracking-[0.4em] text-auto transition-all"
                        style={{ color: 'var(--text-primary)' }}
                    >
                        <span className="relative">
                            Inspecionar Unidade
                            <div className="absolute -bottom-4 left-0 w-0 h-1 transition-all duration-500 group-hover:w-full" style={{ backgroundColor: color || 'var(--accent-color)' }} />
                        </span>
                        <div className="w-12 h-12 rounded-full border border-auto flex items-center justify-center group-hover:bg-auto group-hover:text-main-auto transition-all"
                             style={{ borderColor: 'var(--border-color)' }}>
                            <FiArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                        </div>
                    </button>
                </div>
            </div>

            {/* Rodapé de Série */}
            <div className="absolute bottom-6 right-10 opacity-10">
                <span className="text-[8px] font-black uppercase tracking-[1em]">Titan V11 // Split Engine</span>
            </div>
        </motion.div>
    );
}